import i18n from "@/utils/i18n.utils";
import { z } from "zod";

export const profileSchema = z.object({
  firstName: z
    .string()
    .trim()
    .min(2, i18n.t("inputs.firstName.error"))
    .max(30, i18n.t("inputs.firstName.maxLengthError")),
  lastName: z
    .string()
    .trim()
    .min(2, i18n.t("inputs.lastName.error"))
    .max(30, i18n.t("inputs.lastName.maxLengthError")),
  phoneCode: z.string(),
  phoneNumber: z.string(),
  nationalityCode: z.string(),
  nationality: z.string(),
  countryCode: z.string(),
  country: z.string(),
  gender: z.string(),
  birthdate: z.string(),
}).refine(
  data => !(data.phoneNumber && !data.phoneCode),
  {
    message: i18n.t("inputs.phoneNumber.error"),
    path: ['phoneCode'],
  },
);